import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";

import { merchantApi } from "@api";
import { BGCardPage, ComponentMenuBar, IConClose, IconCard } from "@components";
import { PATH_CARD } from "@configs";
import { IAddCard } from "@interfaces";
import { selectApp, selectAuth, selectMerchant, setCardDetail, setLoading, store } from "@redux";
import UIStore from "@Rocket-Innovation/components/store/useUIStore";
import { RenderMeta, formatMessage, useNotify } from "@utils";
import { Button, Input } from "antd";
import { useTranslation } from "react-i18next";
import { LockCardIcon } from "src/Components/icon/LockIcon";
import { formatDate } from "src/Utils/dateUtil";
import styled from "styled-components";

interface IValue {
    card_num: string;
    card_secret: string;
}

interface ICard {
    cardId: string;
    cardCash: string;
    cardExp: string;
    cardNumber: string;
    imageUrl: string[];
    secretNumber: string;
    isDefault: boolean;
    isDelete: boolean;
    isOnline: boolean;
    isTopup: boolean;
    initialAmount: number;
    maxUsePertime: number;
    isAllmember: boolean;
    isUse: boolean;
    isUseLimit: boolean;
    typeUsegeLimit: string;
    fixUsePertime: string;
    isFreeze: boolean;
}

const INIT_DATA = {
    card_num: "",
    card_secret: "",
};

const INITCARD: ICard = {
    cardId: "",
    cardCash: "",
    cardExp: "",
    cardNumber: "",
    imageUrl: [],
    secretNumber: "",
    isDefault: true,
    isDelete: false,
    isOnline: false,
    isTopup: false,
    initialAmount: 0,
    maxUsePertime: 0,
    isAllmember: false,
    isUse: false,
    isUseLimit: false,
    typeUsegeLimit: "",
    fixUsePertime: "0",
    isFreeze: false,
};

export const PageCard = () => {
    //page hook
    const history = useHistory();
    const dispatch = useDispatch();
    //page redux
    const { loading } = useSelector(selectApp);
    const { userInfo } = useSelector(selectAuth);
    const { themes, memberShipTiers } = useSelector(selectMerchant);
    const merchant = useSelector(selectMerchant);
    const { t } = useTranslation();
    const { success, error } = useNotify();
    const [open, setOpen] = useState<boolean>(false);
    const [value, setValue] = useState<IValue>(INIT_DATA);
    const [cardList, setCardList] = useState<ICard[]>([]);
    const [defaultCard, setDefaultCard] = useState<ICard>(INITCARD);
    useEffect(() => {
        fetchAutoCreate();
    }, []);

    useEffect(() => {
        if (!open) {
            setValue(INIT_DATA);
        }
    }, [open]);

    const handleOpen = () => {
        setOpen(true);
        setValue(INIT_DATA);
    };

    const fetchAutoCreate = async () => {
        let res = await merchantApi.createCardAuto();
        await fetchCard();
        await checkAddCard();
    };

    const checkAddCard = () => {
        //
        let cardDetail = store.getState().page.cardDetail;
        if (cardDetail?.cNum !== "" && cardDetail?.sNum !== "") {
            setOpen(true);
            setValue({
                card_num: cardDetail?.cNum,
                card_secret: cardDetail?.sNum,
            });
            dispatch(
                setCardDetail({
                    sNum: "",
                    cNum: "",
                })
            );
        }
    };

    const fetchCard = async () => {
        try {
            dispatch(setLoading(true));
            // let payload
            let user_id = userInfo?._id || "";
            let res = await merchantApi.getCardList(user_id);
            let cardArr: ICard[] = [];
            let checkDefault = true;
            res?.data?.forEach((cItem: any) => {
                let cObj: ICard = {
                    cardId: cItem.cardId,
                    cardCash: cItem.cardCash,
                    cardExp: cItem.cardExp,
                    cardNumber: cItem.cardNumber,
                    imageUrl: cItem.imageUrl,
                    secretNumber: cItem.secretNumber,
                    isDefault: cItem.isDefault,
                    isDelete: cItem.isDelete,
                    isOnline: cItem.isOnline || false,
                    isTopup: cItem.isTopup,
                    initialAmount: Number(cItem.initialAmount),
                    maxUsePertime: Number(cItem.maxUsePertime),
                    isAllmember: cItem.isAllmember,
                    isUse: cItem.isUse,
                    isUseLimit: cItem?.isUseLimit || false,
                    typeUsegeLimit: cItem?.typeUsegeLimit,
                    fixUsePertime: cItem?.fixUsePertime,
                    isFreeze: cItem?.isFreeze,
                };
                if (cItem?.isAllmember) {
                    setDefaultCard(cObj);
                    checkDefault = false;
                } else {
                    cardArr.push(cObj);
                }
            });
            // if (checkDefault) {
            //     setDefaultCard(cardArr[0]);
            //     cardArr = cardArr.filter((x, index) => index !== 0);
            // }
            setCardList([...cardArr]);
        } catch (err: any) {
            // error(formatMessage(err.response));
            console.error(err);
        } finally {
            dispatch(setLoading(false));
        }
    };

    const confirmAdd = async () => {
        try {
            // let res = await merchantApi
            UIStore.setState({ isLoading: true });
            let payload: IAddCard = {
                cardNumber: value.card_num,
                secretNumber: value.card_secret,
            };
            let res = await merchantApi.addCard(payload);
            if (res.data.status === "200") {
                success(res.data.msg);
                setOpen(false);
                fetchCard();
            } else {
                error(res.data.err);
            }
            // if (res.status === 201) {
            //     success(res.data.msg);
            //     setOpen(false);
            // } else {
            //     error(res.data.msg);
            // }
        } catch (err: any) {
            error(formatMessage(err.response));
        } finally {
            UIStore.setState({ isLoading: false });
        }
    };

    const changeValue = (e: any) => {
        let arr = {
            ...value,
            [e.target.name]: e.target.value,
        };
        setValue({ ...arr });
    };

    const isCardExpired = (cardExp: string): boolean => {
        if (!cardExp) return false;
        const expirationDate = new Date(cardExp);
        const currentDate = new Date();
        return expirationDate < currentDate;
    };

    return (
        <>
            <RenderMeta title={t("meta.card_page")} />
            <StyledReceiptPage themeColor={themes?.themeColor!}>
                <BGCardPage color={themes?.themeColor!} className="ellipse-bg-color" />
                <div className="content">
                    <div className="header">
                        <IconCard />
                        <h1>
                            {merchant.name} {t("page.card.giftCard")}
                        </h1>
                    </div>
                    {!loading ? (
                        cardList?.map((cItem, cIndex) => {
                            if (!cItem?.isDelete && !cItem.isAllmember) {
                                return (
                                    <CardItem
                                        themeColor={themes?.themeColor!}
                                        bg={cItem?.imageUrl?.[0] || ""}
                                        key={cIndex}
                                    >
                                        <div
                                            className="main-card"
                                            onClick={() => {
                                                if (!cItem.isFreeze)
                                                    history.push(
                                                        PATH_CARD + "/" + cItem.cardNumber
                                                    );
                                            }}
                                        >
                                            {cItem.isFreeze && (
                                                <div>
                                                    <div className="lockIcon">
                                                        <div className="lockLayout">
                                                            <LockCardIcon />
                                                            <p className="lockText">
                                                                Your card has been freeze.
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div className="cardOverlay" />
                                                </div>
                                            )}

                                            <p className="card-num">{cItem?.cardNumber}</p>
                                            <div className="card-detail">
                                                {isCardExpired(cItem?.cardExp) && (
                                                    <p className="card-expire">
                                                        {t("page.expired")}
                                                    </p>
                                                )}
                                                <p className="card-cash">
                                                    {new Intl.NumberFormat().format(
                                                        parseInt(cItem?.cardCash || "0")
                                                    )}{" "}
                                                    {t("page.card.thb")}
                                                </p>
                                            </div>
                                        </div>

                                        <div className="sub-card">
                                            {cItem?.isUseLimit &&
                                            cItem?.typeUsegeLimit === "fixUsage" &&
                                            !cItem?.isTopup ? (
                                                <p className="used">
                                                    {t("page.card.used")}: &nbsp;
                                                    {(Number(cItem?.initialAmount) -
                                                        Number(cItem?.cardCash)) /
                                                        Number(cItem?.fixUsePertime)}{" "}
                                                    / &nbsp;
                                                    {Number(cItem?.initialAmount) /
                                                        Number(cItem?.fixUsePertime)}
                                                    &nbsp; {t("page.card.time")}
                                                </p>
                                            ) : (
                                                <p></p>
                                            )}
                                            <p className="exp">
                                                exp:{" "}
                                                {cItem?.cardExp
                                                    ? formatDate(cItem?.cardExp)
                                                    : "No Expiry"}
                                            </p>
                                        </div>
                                    </CardItem>
                                );
                            }
                        })
                    ) : (
                        <StyledLoading />
                    )}
                </div>
                {cardList?.length < 1 ? (
                    <div className="wrapper-empty-card">
                        <div className="empty-card">
                            <img src="../images/ic-card-empty.png " alt="" />
                            <p>- Please Add Card -</p>
                            <span className="prop-left"></span>
                            <span className="prop-right"></span>
                        </div>
                    </div>
                ) : null}

                <div className="empty-div"></div>
                <div className="box-addcard">
                    <Button className="add-card-btn" onClick={handleOpen}>
                        + {t("page.card.add_card")}
                    </Button>
                </div>
                <div>
                    {open && (
                        <StyledDrawer themeColor={themes?.themeColor!}>
                            <div className="content-layout">
                                <div className="content">
                                    <div className="header">
                                        <div className="close" onClick={() => setOpen(false)}>
                                            <IConClose />
                                        </div>
                                    </div>
                                    <div className="input-section">
                                        <p className="title">
                                            {merchant.name} {t("page.card.input_card_num")}
                                        </p>
                                        <Input
                                            className="card-input"
                                            name="card_num"
                                            placeholder={t("page.card.place_card_num")}
                                            value={value.card_num}
                                            onChange={changeValue}
                                        />
                                        <p className="title">{t("page.card.input_card_ser")}</p>
                                        <Input
                                            className="card-input"
                                            name="card_secret"
                                            placeholder={t("page.card.place_card_ser")}
                                            value={value.card_secret}
                                            onChange={changeValue}
                                        />
                                        <Button className="add-btn" onClick={confirmAdd}>
                                            + {t("page.card.add_card")}
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </StyledDrawer>
                    )}
                </div>
                <div className="empty-space" />
                <ComponentMenuBar />
            </StyledReceiptPage>
        </>
    );
};

const StyledReceiptPage = styled.div<{ themeColor: string }>`
    height: 100vh;
    .ellipse-bg-color {
        position: absolute;
    }
    .content {
        position: relative;
        z-index: 1;
        .header {
            display: flex;
            padding: 40px 20px 0 20px;
            grid-gap: 15px;
            h1 {
                z-index: 999;
                font-size: 20px;
                font-weight: 500;
                /* color:  ${(p) => p.themeColor}; */
                color: white;
                padding-bottom: 25px;
                /* border-bottom: 1px solid ${(p) => p.themeColor}70; */
            }
        }
        .main-card {
            margin: 0 20px;
            padding: 20px;
            border-radius: 25px;
            background-color: #fff;
            background-image: "url(" ")";
            background-size: cover;
            cursor: pointer;
            min-height: 230px;
            box-shadow: 0px 0px 10px 1px #0000001f;
            .card-num {
                // color: ${(p) => p.themeColor};
                color: #fff;
            }
            .card-detail {
                display: flex;
                grid-gap: 5px;
                margin-top: 140px;
                p {
                    margin: 0;
                }
                .card-expire {
                    background-color: #f22f46;
                    width: fit-content;
                    color: white;
                    padding: 2px 12px 4px;
                    border-radius: 50px;
                    color: #fff;
                }
                .card-cash {
                    background-color: ${(p) => p.themeColor};
                    width: fit-content;
                    color: white;
                    padding: 2px 12px 4px 12px;
                    border-radius: 50px;
                    opacity: 0.8;
                }
                .card-mem {
                    background-color: ${(p) => p.themeColor};
                    width: fit-content;
                    color: white;
                    padding: 2px 12px 4px 12px;
                    border-radius: 50px;
                    opacity: 0.8;
                }
            }
        }
        .banner-section {
            margin: 20px 20px;
            border-radius: 25px;
            background-color: ${(p) => p.themeColor}10;
            height: 145px;
            overflow: hidden;
            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }
        .more-card {
            margin: 20px;
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            grid-gap: 20px;

            .more-btn {
                width: 100%;
                height: 130px;
                font-weight: 600;
                display: flex;
                justify-content: center;
                border: 1px dashed ${(p) => p.themeColor};
                background-color: #f6f6f6;
                color: ${(p) => p.themeColor};
                border-radius: 16px;
                grid-gap: 5px;
                cursor: pointer;
                align-items: center;
                p {
                    margin-bottom: 0;
                }
            }
            .card-show {
                width: 100%;
                height: 130px;
                /* border: 1px solid ${(p) => p.themeColor}; */
                border-radius: 16px;
                cursor: pointer;
                box-shadow: 0px 0px 10px 1px #2121211f;
                position: relative;
                .card-num {
                    // color: ${(p) => p.themeColor};
                    color: #fff;
                }
                .bg-card {
                    position: absolute;
                    z-index: -1;
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    border-radius: 16px;
                }
                .card-num-count {
                    display: flex;
                    justify-content: space-between;
                    margin: 5px 10px;
                    font-size: 12px;
                }
                .card-cash {
                    margin: 5px 10px;
                    margin-top: 60px;
                    background-color: ${(p) => p.themeColor};
                    width: fit-content;
                    color: white;
                    padding: 2px 12px 4px 12px;
                    border-radius: 50px;
                    font-size: 12px;
                    opacity: 0.8;
                }
                .card-mem {
                    margin: 5px 10px;
                    background-color: ${(p) => p.themeColor};
                    width: fit-content;
                    color: white;
                    padding: 2px 12px 4px 12px;
                    border-radius: 50px;
                    font-size: 12px;
                }
            }
        }
    }

    .view-btn {
        width: 100%;
        border: 1px solid ${(p) => p.themeColor};
        border-radius: 50px;
        height: 48px;
        color: ${(p) => p.themeColor};
        font-weight: 600;
        display: flex;
        justify-content: center;
        padding-top: 12px;
    }

    .btn-section {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-gap: 20px;

        position: fixed;
        bottom: 40px;
        width: 440px;
        max-width: 100vw;
        display: flex;
        justify-content: space-around;

        .btn {
            width: 100%;
            height: 48px;
            border-radius: 50px;
            font-size: 16px;
            font-weight: 600;
            box-shadow: none;
        }
        .back {
            border: 1px solid ${(p) => p.themeColor};
            color: black;
        }
        .confirm {
            border: 1px solid ${(p) => p.themeColor};
            color: white;
            background-color: ${(p) => p.themeColor};
        }
    }
    .example-modal {
        position: fixed;
        bottom: 0px;
        width: 480px;
        max-width: 100vw;
        background-color: pink;
        height: 50vh;
        border-radius: 25px 25px 0 0;
    }
    .box-addcard {
        position: fixed;
        bottom: 120px;
        width: 100%;
        text-align: center;
        left: 0;
        z-index: 5;
        .add-card-btn {
            width: calc(100% - 40px);
            max-width: 440px;
            height: 48px;
            border-radius: 50px;
            background-color: ${(p) => p.themeColor};
            color: white;
            border: none;
        }
    }
    .empty-div {
        min-height: 180px;
    }
    .wrapper-empty-card {
        position: relative;
        padding: 0 20px;
        .empty-card {
            background-color: #f2f5f9;
            display: flex;
            height: 200px;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            position: relative;
            border-top-left-radius: 20px;
            border-top-right-radius: 20px;
            img {
                width: 42px;
                margin-bottom: 4px;
            }
            p {
                font-size: 14px;
                line-height: 17px;
                font-weight: 600;
                color: ${(p) => p.themeColor};
            }
            .prop-left {
                position: absolute;
                width: 107px;
                height: 6px;
                border-radius: 20px;
                background-color: #c0cadf;
                bottom: -19px;
                left: 12px;
                z-index: 1;
            }
            .prop-right {
                position: absolute;
                width: 54px;
                height: 6px;
                border-radius: 20px;
                background-color: #dadfeb;
                bottom: -19px;
                right: 12px;
                z-index: 1;
            }
            &:after {
                content: "";
                width: 100%;
                padding: 15px;
                bottom: -32px;
                left: 0;
                background-color: #ff0000;
                position: absolute;
                border-bottom-right-radius: 20px;
                border-bottom-left-radius: 20px;
                background-color: #f2f5f9;
            }
            &:before {
                content: "";
                width: 100%;
                height: 100%;
                border: 1px dashed ${(p) => p.themeColor};
                position: absolute;
                left: 0;
                top: 0;
                border-radius: 20px;
            }
        }
    }
`;

const StyledDrawer = styled.div<{ themeColor: string }>`
    height: 100vh;
    width: 100%;
    position: fixed;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 480px;
    background: rgba(0, 0, 0, 0.5);
    z-index: 10;
    left: 50%;
    transform: translateX(-50%);
    flex-direction: column;
    justify-content: end;
    .content-layout {
        height: 60dvh;
        background-color: #fff;
    }
    .header {
        width: 100%;
        padding: 16px 24px;
        background: ${(p) => p.theme.colors.card};
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-radius: 8px 8px 0px 0px;
        color: inherit;
    }
    .content {
        width: 480px;
        max-width: 100vw;
        padding-bottom: 28px;
        background: ${(p) => p.theme.colors.card};
        position: relative;
        border-radius: 16px 16px 0 0;
        bottom: 0;
        margin: auto;
        padding-bottom: 0;
        .close {
            position: absolute;
            top: 20px;
            right: 20px;
            cursor: pointer;
            transform: rotate(0deg);
            transition: 0.6s;
            &:hover {
                transform: rotate(90deg);
            }
        }
        .input-section {
            padding: 0px 20px;
            color: ${(p) => p.themeColor};
            .title {
                margin-top: 15px;
                margin-bottom: 5px;
            }
            .card-input {
                padding: 25px 10px;
                border-radius: 15px;
            }
            .add-btn {
                color: white;
                background-color: ${(p) => p.themeColor};
                border-radius: 30px;
                width: 100%;
                margin: 30px 0;
                height: 60px;
            }
        }
    }
`;

const CardItem = styled.div<{ themeColor: string; bg: string }>`
    margin-bottom: 30px;
    .main-card {
        margin: 0 20px;
        padding: 20px;
        border-radius: 25px;
        background-color: #fff;
        background-image: ${(p) => "url(" + p.bg + ")"};
        background-size: cover;
        cursor: pointer;
        min-height: 230px;
        box-shadow: 0px 0px 10px 1px #0000001f;
        position: relative;
        z-index: 2;
        &.freeze {
            // background: rgba(0, 0, 0, 0.5);
            opacity: 0.5;
        }
        .lockIcon {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            z-index: 2;
        }
        .lockLayout {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            gap: 5px;
        }
        .lockText {
            color: #fff;
            font-size: 12px;
            font-style: normal;
            font-weight: 600;
            line-height: normal;
        }
        .cardOverlay {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            z-index: 1;
            background: rgba(0, 0, 0, 0.5);
            border-radius: 25px;
        }
        .card-num {
            // color: ${(p) => p.themeColor};
            color: #fff;
        }
        .card-detail {
            display: flex;
            grid-gap: 5px;
            margin-top: 140px;
            p {
                margin: 0;
            }
            .card-cash {
                background-color: ${(p) => p.themeColor};
                width: fit-content;
                color: white;
                padding: 2px 12px 4px 12px;
                border-radius: 50px;
                opacity: 0.8;
            }
            .card-mem {
                background-color: ${(p) => p.themeColor};
                width: fit-content;
                color: white;
                padding: 2px 12px 4px 12px;
                border-radius: 50px;
                opacity: 0.8;
            }
        }
    }
    .sub-card {
        margin: 0 20px;
        background-color: #f2f5f9;
        /* background-color: coral; */
        height: 50px;
        padding: 30px 20px;
        margin-top: -20px;
        position: relative;
        z-index: 1;
        border-radius: 0 0 25px 25px;
        display: grid;
        grid-template-columns: 1fr 1fr;
        .used {
            color: ${(p) => p.themeColor};
        }
        .exp {
            color: #9daaae;
            text-align: right;
        }
    }
`;

const StyledLoading = styled.div`
    display: flex;
    width: 100%;
    height: 100dvh;
    /* background-color: #ffffff; */
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1;
    background-image: url(/images/img-loading.gif);
    background-repeat: no-repeat;
    background-position: center;
    background-size: 50px;
`;
